import { render, staticRenderFns } from "./GUserLevel.vue?vue&type=template&id=1532a16a"
import script from "./GUserLevel.vue?vue&type=script&lang=js"
export * from "./GUserLevel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports